import { render, staticRenderFns } from "./GiveFeedback.vue?vue&type=template&id=790b2f64&scoped=true&"
import script from "./GiveFeedback.vue?vue&type=script&lang=js&"
export * from "./GiveFeedback.vue?vue&type=script&lang=js&"
import style0 from "./GiveFeedback.vue?vue&type=style&index=0&id=790b2f64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790b2f64",
  null
  
)

export default component.exports